import { Chips } from '@tajawal/ct-web-design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Styled from './BaggageFilter.styled';
import _map from 'lodash/map';
import { getBaggageOptionLabel } from '@/utils/content.utils';
import type SingleSelectFilterType from '@tajawal/web-flights-sdk/lib/stores/filter/base/single-select-filter.store';
import { useStateOfSingleSelectFilter } from '@/hooks/useStateOfSingleSelectFilter';
import { buildTestId } from '@/utils/helpers.utils';
import { FilterCode } from '@tajawal/web-flights-sdk/lib/types/filters/index.types';
import _isFunction from 'lodash/isFunction';
import { pushFilterChangeGtmEvent } from '@/utils/avoGtm.utils';

type BaggageFilterProps = {
  filter: SingleSelectFilterType;
  testId: string;
  onSelect?: (code: FilterCode) => void;
  isQuickFilter?: boolean;
};

function BaggageFilter({ filter, testId, onSelect, isQuickFilter }: BaggageFilterProps) {
  const { t } = useTranslation();
  const { state, set } = useStateOfSingleSelectFilter(filter);

  const handleSelect = (code: FilterCode) => {
    pushFilterChangeGtmEvent(filter.id, code, isQuickFilter);
    set(code, true);
    _isFunction(onSelect) && onSelect(code);
  };

  return (
    <Styled.ChipsWrapper>
      {_map(state, (option) => {
        return (
          <Chips
            key={String(option.code)}
            type="filter"
            onClick={() => handleSelect(option.code)}
            isSelected={option.selected}
            label={getBaggageOptionLabel(option.code, t)}
            isClickable
            testId={buildTestId(testId, String(option.code))}
            isDisabled={!option.isAvailable}
          />
        );
      })}
    </Styled.ChipsWrapper>
  );
}

export default BaggageFilter;
